module.exports = __webpack_public_path__ + "img/Avatar-1.b03f0bb6.svg";